import { Component, Input } from '@angular/core';
import { OwnerInterface } from '@app/interfaces/owner.interface';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-contact-specialist',
    templateUrl: './contact-specialist.component.html',
    styleUrls: ['./contact-specialist.component.scss'],
    imports: [MatIcon],
})
export class ContactSpecialistComponent {
    @Input() owner: OwnerInterface;
}
